var numeral = require("numeral");

export default {
	filters: {
		// 천단위 콤마
		comma: function (value) {
			return numeral(value).format("0,0");
		},
		// 소수점 이하를 반올림
		round: function (value) {
			return Math.round(value)
		},
		// 랜덤숫자
		randomNumber: function () {
			let min = 1
			let max = 6
			return Math.floor(Math.random() * (max - min + 1)) + min
		},
		// 숫자앞에 0 채우기
		leftPad: function (value, len) {
			value = value + '';
			return value.length >= len ? value : new Array(len - value.length + 1).join('0') + value;
		},
		// 문자열 길이
		length: function (value) {
			if (value) return value.length;
			else return 0;
		},
		// 지식인글 코드값에서 글자로 변경
		filterStrKnowledgeInStatusName: function (str) {
			if (str === 'READY') {
				return '질문';
			} else if (str === 'CHOICE') {
				return '질문';
			} else if (str === 'EXPIRED') {
				return '종료';
			} else if (str === 'FINISH') {
				return '질문';
			}
		},
		// 파일용량 명칭 변경
		getfileSize: function (val) {
			let x = val * 1024;
			let s = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
			let e = Math.floor(Math.log(x) / Math.log(1024));
			return (x / Math.pow(1024, e)).toFixed(0) + " " + s[e];
		},
	}
}
